import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  PID: {
    DOM: 0,
    INTL: 0
  }
}

export const DistrictM = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  // console.log('Prebid: ', PREBID)
  const { VENDOR } = PREBID
  const DISTRICTM = { ...template, ...VENDOR }
  const { PID } = DISTRICTM
  const { DOM, INTL } = PID
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='DistrictM-panel-content'
        id='DistrictM-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>DistrictM</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Table size='small' aria-label='districtm-publisher-id-table'>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '180px' }}><Typography variant='h6'>Publisher IDs</Typography></TableCell>
              <TableCell>Domestic</TableCell>
              <TableCell>International</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  margin='none'
                  value={DOM}
                  error={errors.PREBID_DISTRICTM_PIDD}
                  helperText={errors.PREBID_DISTRICTM_PIDD && LENGTH.message}
                  onChange={(event) => {
                    const value = event.target.value
                    PREBID.VENDOR.DISTRICTM.PID.DOM = value
                    setErrors({ ...errors, PREBID_DISTRICTM_PIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  margin='none'
                  value={INTL}
                  error={errors.PREBID_DISTRICTM_PIDI}
                  helperText={errors.PREBID_DISTRICTM_PIDI && LENGTH.message}
                  onChange={(event) => {
                    const value = event.target.value
                    PREBID.VENDOR.DISTRICTM.PID.INTL = value
                    setErrors({ ...errors, PREBID_DISTRICT_PIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
